// extracted by mini-css-extract-plugin
export default {"tiny-text":"ElffOO","tinyText":"ElffOO","tiny-link":"ebpjZ2","tinyLink":"ebpjZ2"};